module.exports = __webpack_public_path__ + "img/hyperlink-2.1b67d5c8.svg";